import { Delete } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from '@mui/material';
import React, { useState } from 'react';

interface IProps {
  itemText: string;
  functionToDelete: Function;
}

export const ConfirmDelete: React.FC<IProps> = ({
  itemText,
  functionToDelete,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <DialogTitle>Löschungsbestätigung</DialogTitle>
        <DialogContent>
          Sind Sie sicher, dass Sie {itemText} löschen wollen?
        </DialogContent>
        <DialogActions>
          <Button
            variant='contained'
            color='error'
            onClick={() => {
              functionToDelete();
              setIsOpen(false);
            }}
          >
            Löschen
          </Button>
          <Button
            variant='contained'
            color='success'
            onClick={() => setIsOpen(false)}
          >
            Abbruch
          </Button>
        </DialogActions>
      </Dialog>

      <Tooltip title={itemText + ' löschen'}>
        <IconButton size='small' onClick={() => setIsOpen(true)}>
          <Delete />
        </IconButton>
      </Tooltip>
    </>
  );
};
